import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { fetchUserPreferences, setCoverPageInfo, setCoverPageInfoFailure, setUserPreferencesFetchFailure, setUserPreferencesFetchSuccess, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/cover-page/cover-page.actions';
import { resetSelectedReport, setReportTitle, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selected-report/selected-report.actions';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { getCoverPageErrorStatus, getCoverPageInfo, getCoverPageLoadingStatus, getCurrentWizardStepIndex, getDefaultReportTitle, getIsLastStep, getSelectedReport, getWizardStepEventName, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { AS_OF_DATE_DROPDOWN_CONFIG, AS_OF_DATE_LATEST, REPORT_TYPE_LABELS } from 'CustomPDFReportsApp/ts/constants';
import { REPORT_CONTACT_EMAIL_MAX_LENGTH, REPORT_CONTACT_PHONE_MAX_LENGTH, REPORT_CONTACT_URL_MAX_LENGTH, REPORT_CUSTOM_FIELD_MAX_LENGTH, REPORT_ORGANIZATION_MAX_LENGTH, REPORT_PREPARED_BY_MAX_LENGTH, REPORT_PREPARED_FOR_MAX_LENGTH, REPORT_TITLE_MAX_LENGTH, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/constants';
import { CustomPDFReportDesignation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-designation.enum';
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { CustomPDFReportService } from 'CustomPDFReportsApp/ts/services/custom-pdf-report.service';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "NewAngular/services/core/ajax.service";
import * as i3 from "CustomPDFReportsApp/ts/services/custom-pdf-report.service";
import * as i4 from "NewAngular/services/core/urls.service";
import * as i5 from "@ngrx/store";
import * as i6 from "@angular/common";
import * as i7 from "@angular/forms";
import * as i8 from "../../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i9 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i10 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i11 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i12 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
const _c0 = a0 => ({ disabled: a0 });
const _c1 = a0 => ({ "is-invalid": a0 });
function CoverPageModuleModalComponent_ycn_loading_symbol_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 5);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Loading...");
} }
function CoverPageModuleModalComponent_div_3_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵelement(2, "label", 26);
    i0.ɵɵelementStart(3, "input", 27);
    i0.ɵɵtwoWayListener("ngModelChange", function CoverPageModuleModalComponent_div_3_ng_container_7_Template_input_ngModelChange_3_listener($event) { const field_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r3[field_r3.fieldName], $event) || (ctx_r3[field_r3.fieldName] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function CoverPageModuleModalComponent_div_3_ng_container_7_Template_input_ngModelChange_3_listener() { const field_r3 = i0.ɵɵrestoreView(_r2).$implicit; return i0.ɵɵresetView(field_r3.fieldOnChange()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("textContent", field_r3.fieldIsRequired ? field_r3.fieldLabel + "*" : field_r3.fieldLabel);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("form-control");
    i0.ɵɵproperty("id", field_r3.fieldName)("type", field_r3.fieldType)("ngClass", i0.ɵɵpureFunction1(9, _c1, ctx_r3.hasInvalidInputMapping[field_r3.fieldName]));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3[field_r3.fieldName]);
    i0.ɵɵproperty("disabled", field_r3.fieldIsDisabled)("placeholder", field_r3.fieldPlaceholder);
} }
function CoverPageModuleModalComponent_div_3_ng_container_9_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelement(1, "label", 26);
    i0.ɵɵelementStart(2, "input", 27);
    i0.ɵɵtwoWayListener("ngModelChange", function CoverPageModuleModalComponent_div_3_ng_container_9_div_2_Template_input_ngModelChange_2_listener($event) { const field_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r3 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r3[field_r6.fieldName], $event) || (ctx_r3[field_r6.fieldName] = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("ngModelChange", function CoverPageModuleModalComponent_div_3_ng_container_9_div_2_Template_input_ngModelChange_2_listener() { const field_r6 = i0.ɵɵrestoreView(_r5).$implicit; return i0.ɵɵresetView(field_r6.fieldOnChange()); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const field_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", field_r6.fieldIsRequired ? field_r6.fieldLabel + "*" : field_r6.fieldLabel);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("form-control");
    i0.ɵɵproperty("id", field_r6.fieldName)("type", field_r6.fieldType)("ngClass", i0.ɵɵpureFunction1(9, _c1, ctx_r3.hasInvalidInputMapping[field_r6.fieldName]));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r3[field_r6.fieldName]);
    i0.ɵɵproperty("disabled", field_r6.fieldIsDisabled)("placeholder", field_r6.fieldPlaceholder);
} }
function CoverPageModuleModalComponent_div_3_ng_container_9_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "label", 32);
    i0.ɵɵtext(2, "Performance/Risk Data As Of:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "ycn-single-select-dropdown", 33);
    i0.ɵɵlistener("changeHandler", function CoverPageModuleModalComponent_div_3_ng_container_9_div_3_Template_ycn_single_select_dropdown_changeHandler_3_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r3 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r3.asOfDateHandler($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("config", ctx_r3.asOfDateConfig)("selectedValue", ctx_r3.asOfDateOption)("customCssClasses", ctx_r3.asOfDateCssConfig);
} }
function CoverPageModuleModalComponent_div_3_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 28);
    i0.ɵɵtemplate(2, CoverPageModuleModalComponent_div_3_ng_container_9_div_2_Template, 3, 11, "div", 29)(3, CoverPageModuleModalComponent_div_3_ng_container_9_div_3_Template, 4, 3, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const fieldRow_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", fieldRow_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i_r9 == ctx_r3.modalFieldRows.length - 1);
} }
function CoverPageModuleModalComponent_div_3_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 37);
} if (rf & 2) {
    const error_r10 = ctx.$implicit;
    i0.ɵɵproperty("textContent", error_r10);
} }
function CoverPageModuleModalComponent_div_3_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34)(1, "div", 35);
    i0.ɵɵtemplate(2, CoverPageModuleModalComponent_div_3_div_10_div_2_Template, 1, 1, "div", 36);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.errorMessages);
} }
function CoverPageModuleModalComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 6)(2, "div", 7);
    i0.ɵɵelement(3, "div", 8);
    i0.ɵɵelementStart(4, "div", 9)(5, "small");
    i0.ɵɵtext(6, "* Required information.");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, CoverPageModuleModalComponent_div_3_ng_container_7_Template, 4, 11, "ng-container", 10);
    i0.ɵɵpipe(8, "slice");
    i0.ɵɵtemplate(9, CoverPageModuleModalComponent_div_3_ng_container_9_Template, 4, 2, "ng-container", 10)(10, CoverPageModuleModalComponent_div_3_div_10_Template, 3, 1, "div", 11);
    i0.ɵɵelement(11, "div", 12);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 13)(13, "div", 14)(14, "div", 15)(15, "label", 16)(16, "input", 17);
    i0.ɵɵlistener("change", function CoverPageModuleModalComponent_div_3_Template_input_change_16_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.fieldDesignationChange($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(17, "span", 18);
    i0.ɵɵelementStart(18, "span", 19);
    i0.ɵɵtext(19, "Print as Draft");
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(20, " \u00A0 ");
    i0.ɵɵelementStart(21, "span", 20);
    i0.ɵɵlistener("click", function CoverPageModuleModalComponent_div_3_Template_span_click_21_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r11 = i0.ɵɵreference(24); return i0.ɵɵresetView(helpModal_r11.openModal("print_as_draft")); });
    i0.ɵɵtext(22, "(?)");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(23, "ycn-help-modal", 21, 0);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(25, "div", 22)(26, "div", 23);
    i0.ɵɵlistener("click", function CoverPageModuleModalComponent_div_3_Template_div_click_26_listener() { i0.ɵɵrestoreView(_r1); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.exitModalHandler()); });
    i0.ɵɵtext(27, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 24);
    i0.ɵɵlistener("click", function CoverPageModuleModalComponent_div_3_Template_div_click_28_listener() { i0.ɵɵrestoreView(_r1); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.back()); });
    i0.ɵɵtext(29, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 25);
    i0.ɵɵlistener("click", function CoverPageModuleModalComponent_div_3_Template_div_click_30_listener() { i0.ɵɵrestoreView(_r1); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.forward()); });
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("textContent", ctx_r3.subHeaderText);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(8, 7, ctx_r3.modalFields, 0, 2));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.modalFieldRows);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.errorMessages.length);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("checked", ctx_r3.designationTypeOption === ctx_r3.CustomPDFReportDesignation.DRAFT);
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(11, _c0, ctx_r3.hasInvalidInput))("innerText", ctx_r3.buttonText);
} }
function CoverPageModuleModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 6)(2, "div", 7)(3, "div", 38);
    i0.ɵɵtext(4, " An error occurred. Please try again or contact us with details of your problem. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div", 13);
    i0.ɵɵelementEnd()();
} }
export class CoverPageModuleModalComponent {
    constructor(accountsService, ajaxService, customPdfService, urlsService, store) {
        this.accountsService = accountsService;
        this.ajaxService = ajaxService;
        this.customPdfService = customPdfService;
        this.urlsService = urlsService;
        this.store = store;
        this.broadcastWizardStepEvent = new EventEmitter();
        this.USER = window.USER;
        this.CustomPDFReportDesignation = CustomPDFReportDesignation;
        this.isOpen = false;
        this.reportType = null;
        this.buttonText = '';
        this.subHeaderText = 'Customize your report';
        this.defaultReportTitle = '';
        // The user cannot change the "Prepared By" field in the modal itself, we pull
        // it down from the `UserPreferenceService`
        this.reportPreparedBy = null;
        // We need user input for these
        this.userInputReportTitle = null;
        this.userInputContactEmail = null;
        this.userInputContactPhone = null;
        this.userInputContactUrl = null;
        this.userInputPreparedFor = null;
        this.userInputOrganization = null;
        this.userInputCustomField = null;
        this.asOfDateOption = AS_OF_DATE_LATEST;
        this.designationTypeOption = CustomPDFReportDesignation.DELIVERABLE;
        this.isLastStep = null;
        this.isLoading = false;
        this.fetchErrorOccurred = false;
        this.reportRegeneration = false;
        this.hasInvalidInput = false;
        this.errorMessages = [];
        this.modalFields = [];
        this.modalFieldRows = [];
        this.modalFieldTemplate = [
            {
                fieldName: 'userInputReportTitle',
                fieldLabel: 'Report title',
                fieldType: 'text',
                fieldPlaceholder: 'Enter report title',
                fieldValidators: [this.fieldIsBlank, this.createFieldLengthValidator(REPORT_TITLE_MAX_LENGTH)],
                fieldIsRequired: false,
                fieldIsDisabled: false,
                fieldOnChange: () => { },
            },
            {
                fieldName: 'userInputPreparedFor',
                fieldLabel: 'Prepared for',
                fieldType: 'text',
                fieldPlaceholder: "Enter recipient's name",
                fieldValidators: [this.fieldIsBlank, this.createFieldLengthValidator(REPORT_PREPARED_FOR_MAX_LENGTH)],
                fieldIsRequired: true,
                fieldIsDisabled: false,
                fieldOnChange: () => { },
            },
            {
                fieldName: 'reportPreparedBy',
                fieldLabel: 'Prepared by',
                fieldType: 'text',
                fieldPlaceholder: 'Prepared by',
                fieldValidators: [this.fieldIsBlank, this.createFieldLengthValidator(REPORT_PREPARED_BY_MAX_LENGTH)],
                fieldIsRequired: true,
                fieldIsDisabled: window.USER.impersonationState.userImpersonating,
                fieldOnChange: () => { },
                backendFieldName: 'default_prepared_by_name',
            },
            {
                fieldName: 'userInputOrganization',
                fieldLabel: 'Organization',
                fieldType: 'text',
                fieldPlaceholder: 'Enter organization',
                fieldValidators: [this.createFieldLengthValidator(REPORT_ORGANIZATION_MAX_LENGTH)],
                fieldIsRequired: false,
                fieldIsDisabled: false,
                fieldOnChange: () => { },
                backendFieldName: 'default_organization',
            },
            {
                fieldName: 'userInputContactPhone',
                fieldLabel: 'Contact phone',
                fieldType: 'text',
                fieldPlaceholder: 'Enter contact phone',
                fieldValidators: [this.fieldIsBlank, this.createFieldLengthValidator(REPORT_CONTACT_PHONE_MAX_LENGTH)],
                fieldIsRequired: true,
                fieldIsDisabled: false,
                fieldOnChange: () => { },
                backendFieldName: 'default_contact_phone',
            },
            {
                fieldName: 'userInputContactEmail',
                fieldLabel: 'Contact Email',
                fieldType: 'text',
                fieldPlaceholder: 'Enter contact Email',
                fieldValidators: [
                    this.emailFieldValidator,
                    this.createFieldLengthValidator(REPORT_CONTACT_EMAIL_MAX_LENGTH),
                ],
                fieldIsRequired: false,
                fieldIsDisabled: false,
                fieldOnChange: () => { },
                backendFieldName: 'default_contact_email',
            },
            {
                fieldName: 'userInputContactUrl',
                fieldLabel: 'Contact URL',
                fieldType: 'text',
                fieldPlaceholder: 'Enter contact URL',
                fieldValidators: [this.fieldIsBlank, this.createFieldLengthValidator(REPORT_CONTACT_URL_MAX_LENGTH)],
                fieldIsRequired: true,
                fieldIsDisabled: false,
                fieldOnChange: () => { },
                backendFieldName: 'default_contact_url',
            },
            {
                fieldName: 'userInputCustomField',
                fieldLabel: 'Custom Field',
                fieldType: 'text',
                fieldPlaceholder: 'Enter custom field value',
                fieldValidators: [this.createFieldLengthValidator(REPORT_CUSTOM_FIELD_MAX_LENGTH)],
                fieldIsRequired: false,
                fieldIsDisabled: false,
                fieldOnChange: () => { },
            },
        ];
        this.asOfDateConfig = AS_OF_DATE_DROPDOWN_CONFIG;
        this.asOfDateCssConfig = {
            button: 'btn btn-secondary btn-block style-underline',
        };
        this.currentWizardStepIndex = null;
        this.mapStateToComponent = (state) => {
            const selectedReport = getSelectedReport(state);
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.coverPageInfo = getCoverPageInfo(state);
            this.defaultReportTitle = getDefaultReportTitle(state);
            // Rehydrate variables from state values
            this.reportRegeneration = state.reportRegeneration;
            this.userInputContactEmail = this.coverPageInfo.contactEmail;
            this.userInputContactPhone = this.coverPageInfo.contactPhone;
            this.userInputContactUrl = this.coverPageInfo.contactUrl;
            this.userInputOrganization = this.coverPageInfo.organization;
            this.userInputPreparedFor = this.coverPageInfo.preparedFor;
            this.reportPreparedBy = this.coverPageInfo.preparedBy;
            this.asOfDateOption = this.coverPageInfo.asOfDateOption;
            this.designationTypeOption = this.coverPageInfo.designationType;
            this.userInputCustomField = this.coverPageInfo.customField;
            if (state.reportTitle) {
                this.userInputReportTitle = state.reportTitle;
            }
            else {
                this.userInputReportTitle = this.defaultReportTitle;
            }
            if (selectedReport &&
                !this.isOpen &&
                this.currentWizardStepIndex === 0 &&
                getWizardStepEventName(state) === CustomPDFReportModalEventName.SHOW_COVER_PAGE_MODULE_MODAL) {
                this.openModal();
            }
            this.isLastStep = getIsLastStep(state);
            this.isLoading = getCoverPageLoadingStatus(state);
            this.fetchErrorOccurred = getCoverPageErrorStatus(state);
            this.reportType = selectedReport.report_type;
            const reportTypeLabel = REPORT_TYPE_LABELS[this.reportType] ?? '';
            if (this.reportType && reportTypeLabel) {
                this.subHeaderText = `Customize your ${reportTypeLabel} Report.`;
            }
            else {
                this.subHeaderText = 'Customize your report.';
            }
            this.buttonText = this.isLastStep ? 'Generate' : 'Next';
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
        // Map over the fields to add the `fieldOnChange` methods to the objects
        this.modalFields = this.modalFieldTemplate.map((field) => {
            /* eslint-disable no-param-reassign */
            field.fieldOnChange = this.fieldOnChangeCreator(field);
            return field;
        });
        // Fields are displayed in rows of 2
        for (let i = 2; i < this.modalFields.length; i += 2) {
            this.modalFieldRows.push(this.modalFields.slice(i, i + 2));
        }
        // Map over the fields to set up our initial `hasInvalidInputMapping` state
        this.hasInvalidInputMapping = this.modalFieldTemplate.reduce((acc, field) => {
            return { ...acc, [field.fieldName]: false };
        }, {});
        // Map over the fields to set up our initial `errorMessageMapping` state
        this.errorMessageMapping = this.modalFieldTemplate.reduce((acc, field) => {
            return { ...acc, [field.fieldName]: new Set() };
        }, {});
    }
    /**
     * Returns a function for use in the `ngModelChange` binding for the given field. Includes
     * logic to map over an array of `fieldValidators`, which should return either a
     * `String` message or `null`. Finally, it adds the error message (if any) to the
     * appropriate mapping in `errorMessageMapping`, and sets the `hasInvalidInputMapping`
     * for the appropriate field.
     *
     * @param {Object} field An object containing data for a given modal field
     * @returns {Function} A function to be passed to the `ngModelChange` binding on the
     *                    `input` tag
     */
    fieldOnChangeCreator(field) {
        const { fieldName, fieldLabel, fieldValidators } = field;
        if (!fieldValidators || fieldValidators.length === 0) {
            return () => { };
        }
        return () => {
            this.errorMessageMapping[fieldName].clear();
            const fieldValue = this[fieldName];
            const errorMessages = fieldValidators
                .map((validator) => validator(fieldValue, fieldLabel))
                .filter((m) => m);
            if (errorMessages.length) {
                errorMessages.map((errorMessage) => this.errorMessageMapping[fieldName].add(errorMessage));
                this.hasInvalidInputMapping[fieldName] = true;
            }
            else {
                this.hasInvalidInputMapping[fieldName] = false;
            }
            this.hasInvalidInput = Object.keys(this.hasInvalidInputMapping).some((key) => this.hasInvalidInputMapping[key]);
            this.errorMessages = this.errorMessagesAsArray();
        };
    }
    fetchUserPreferences() {
        this.store.dispatch(fetchUserPreferences());
        this.accountsService.getUserPreferences().subscribe({
            next: (preferences) => {
                const { default_contact_email, default_contact_phone, default_contact_url, default_organization, default_prepared_by_name, default_report_designation, } = preferences;
                // Set user input to have default values only if blank
                this.userInputContactEmail = this.userInputContactEmail || default_contact_email;
                this.userInputContactPhone = this.userInputContactPhone || default_contact_phone;
                this.userInputContactUrl = this.userInputContactUrl || default_contact_url;
                this.userInputOrganization = this.userInputOrganization || default_organization;
                if (!this.designationTypeOption && default_report_designation === CustomPDFReportDesignation.DRAFT) {
                    this.designationTypeOption = CustomPDFReportDesignation.DRAFT;
                }
                // If reportPreparedBy is blank and the user doesn't have a `default_prepared_by_name`
                // set it to their full name, as reported by the `USER` service.
                if (!this.reportPreparedBy) {
                    if (!default_prepared_by_name) {
                        this.reportPreparedBy = `${this.USER.firstName} ${this.USER.lastName}`;
                    }
                    else {
                        this.reportPreparedBy = default_prepared_by_name;
                    }
                }
                this.store.dispatch(setUserPreferencesFetchSuccess({
                    contactEmail: this.userInputContactEmail,
                    contactPhone: this.userInputContactPhone,
                    contactUrl: this.userInputContactUrl,
                    organization: this.userInputOrganization,
                    preparedBy: this.reportPreparedBy,
                    reportDesignation: this.designationTypeOption,
                }));
            },
            error: () => {
                this.store.dispatch(setUserPreferencesFetchFailure());
            },
        });
    }
    /**
     * Resets the `errorMessageMapping` and `hasInvalidInputMapping` objects to their
     * default state
     *
     */
    resetErrorStates() {
        Object.keys(this.errorMessageMapping).map((key) => this.errorMessageMapping[key].clear());
        this.hasInvalidInputMapping = Object.keys(this.hasInvalidInputMapping).reduce((acc, cur) => {
            return { ...acc, [cur]: false };
        }, {});
        this.hasInvalidInput = false;
        this.errorMessages = [];
    }
    closeModal() {
        this.isOpen = false;
        this.resetErrorStates();
        this.resetUserInputFields();
    }
    openModal() {
        this.fetchUserPreferences();
        this.isOpen = true;
    }
    back() {
        this.closeModal();
        if (this.currentWizardStepIndex) {
            this.store.dispatch(decrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
        }
        else {
            this.store.dispatch(resetSelectedReport());
        }
    }
    exitModalHandler() {
        this.store.dispatch(resetAllCustomPdfReportItems());
        this.closeModal();
    }
    resetUserInputFields() {
        this.userInputContactEmail = null;
        this.userInputContactPhone = null;
        this.userInputContactUrl = null;
        this.userInputOrganization = null;
        this.userInputPreparedFor = null;
        this.userInputReportTitle = null;
        this.userInputCustomField = null;
        this.asOfDateOption = AS_OF_DATE_LATEST;
        this.designationTypeOption = CustomPDFReportDesignation.DELIVERABLE;
    }
    forward() {
        this.validateInput();
        if (!this.hasInvalidInput) {
            const reportTitle = this.userInputReportTitle;
            this.store.dispatch(setCoverPageInfo({
                contactEmail: this.userInputContactEmail,
                contactPhone: this.userInputContactPhone,
                contactUrl: this.userInputContactUrl,
                organization: this.userInputOrganization,
                preparedBy: this.reportPreparedBy,
                preparedFor: this.userInputPreparedFor,
                customField: this.userInputCustomField,
                asOfDateOption: this.asOfDateOption,
                designationType: this.designationTypeOption,
            }));
            this.store.dispatch(setReportTitle({ title: reportTitle }));
            if (this.reportRegeneration === false) {
                this.resetErrorStates();
                // On normal (Not re-gen) report generations, we update the user prefs on every `forward` call
                // to ensure the `default_prepared_by_name` stays in sync.
                this.accountsService
                    .putUserPreferences({
                    default_contact_email: this.userInputContactEmail,
                    default_contact_phone: this.userInputContactPhone,
                    default_contact_url: this.userInputContactUrl,
                    default_organization: this.userInputOrganization,
                    default_prepared_by_name: this.reportPreparedBy,
                    default_report_designation: this.designationTypeOption,
                })
                    .subscribe({
                    next: () => {
                        this.proceedToNextStep();
                    },
                    error: (error) => {
                        // Handle validation errors from the backend - keep modal open to show errors
                        if (error?.status === 400 && error?.error?.errors) {
                            Object.entries(error.error.errors).forEach(([fieldName, errorMessage]) => {
                                const fieldTemplate = this.modalFieldTemplate.find((f) => f.backendFieldName === fieldName);
                                const fieldLabel = fieldTemplate?.fieldLabel || fieldName;
                                const shownMessage = Array.isArray(errorMessage)
                                    ? errorMessage.join('. ')
                                    : errorMessage;
                                this.errorMessages.push(`${fieldLabel}: ${shownMessage}`);
                            });
                            this.hasInvalidInput = true;
                            // Don't close modal or dispatch failure - let user fix the error
                        }
                        else {
                            // For non-validation errors, proceed but dispatch failure
                            this.store.dispatch(setCoverPageInfoFailure());
                            this.proceedToNextStep();
                        }
                    },
                });
            }
            else {
                this.proceedToNextStep();
            }
        }
    }
    /**
     * Closes the modal and advances to the next wizard step.
     */
    proceedToNextStep() {
        this.closeModal();
        this.store.dispatch(incrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
    }
    /**
     * Resets the error mapping states; then maps over all modal fields, calling
     * `fieldOnChange` to populate the error mapping dictionary and set the field
     * invalidation flags.
     */
    validateInput() {
        this.resetErrorStates();
        this.modalFields.map((field) => field.fieldOnChange());
    }
    /**
     * Returns all error messages reduced into an array to allow for ngRepeat iteration.
     */
    errorMessagesAsArray() {
        return Object.keys(this.errorMessageMapping).reduce((acc, cur) => {
            return [...acc, ...this.errorMessageMapping[cur]];
        }, []);
    }
    /**
     * Returns an error message if the given fieldValue does not conform to an email regex.
     */
    emailFieldValidator(fieldValue) {
        if (!fieldValue)
            return null;
        const re = /\S+@\S+\.\S+/;
        return re.test(fieldValue) ? null : 'Email is invalid';
    }
    /**
     * Returns a message if the given fieldValue is an empty string, or if it is null/undefined.
     */
    fieldIsBlank(fieldValue, fieldLabel) {
        const isBlank = fieldValue === '' || fieldValue === null || fieldValue === undefined;
        return isBlank ? `${fieldLabel} cannot be blank` : null;
    }
    /**
     * Returns a function that returns a message if a given fieldValue is greater than maxLength.
     */
    createFieldLengthValidator(maxLength) {
        return (fieldValue, fieldLabel) => {
            // If we don't have a fieldValue, simply return null, as the `fieldIsBlank` validator
            // will catch that case
            if (!fieldValue)
                return null;
            return fieldValue.length > maxLength
                ? `The text length for ${fieldLabel} exceeds the limit of ${maxLength} characters.`
                : null;
        };
    }
    asOfDateHandler(value) {
        this.asOfDateOption = value;
    }
    fieldDesignationChange(event) {
        const checkbox = event.target;
        this.designationTypeOption = checkbox.checked
            ? CustomPDFReportDesignation.DRAFT
            : CustomPDFReportDesignation.DELIVERABLE;
    }
}
CoverPageModuleModalComponent.ɵfac = function CoverPageModuleModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CoverPageModuleModalComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.AjaxService), i0.ɵɵdirectiveInject(i3.CustomPDFReportService), i0.ɵɵdirectiveInject(i4.UrlsService), i0.ɵɵdirectiveInject(i5.Store)); };
CoverPageModuleModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CoverPageModuleModalComponent, selectors: [["ycn-cover-page-module-modal"]], outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 5, vars: 5, consts: [["helpModal", ""], [3, "closeModalHandler", "open"], [3, "closeModalHandler", "header"], [3, "loaderMessage", 4, "ngIf"], [4, "ngIf"], [3, "loaderMessage"], [1, "modal-body"], [1, "modal-section"], [1, "mb-row", "text-bold", "text-gray-40", 3, "textContent"], [1, "mb-3"], [4, "ngFor", "ngForOf"], ["class", "row form-row", 4, "ngIf"], [1, "divider-horizontal"], [1, "modal-footer"], [1, "modal-footer-info"], [1, "text-default"], [1, "custom-control", "custom-checkbox", "mr-0"], ["type", "checkbox", "name", "report-designation", "data-test-id", "cover-page-draft-checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "help-toggler", 3, "click"], ["name", "print_as_draft"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], [1, "btn", "btn-secondary", 3, "click"], [1, "btn", "btn-primary", 3, "click", "ngClass", "innerText"], [1, "form-label", "form-label-thin", "pb-1", 3, "textContent"], [3, "ngModelChange", "id", "type", "ngClass", "ngModel", "disabled", "placeholder"], [1, "row", "mb-3"], ["class", "col-6", 4, "ngFor", "ngForOf"], ["class", "col-6", 4, "ngIf"], [1, "col-6"], [1, "form-label", "form-label-thin", "pb-1"], [1, "dropdown", 3, "changeHandler", "config", "selectedValue", "customCssClasses"], [1, "row", "form-row"], [1, "col"], ["class", "feedback feedback-invalid", 3, "textContent", 4, "ngFor", "ngForOf"], [1, "feedback", "feedback-invalid", 3, "textContent"], [1, "feedback", "feedback-invalid"]], template: function CoverPageModuleModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function CoverPageModuleModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function CoverPageModuleModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, CoverPageModuleModalComponent_ycn_loading_symbol_2_Template, 1, 1, "ycn-loading-symbol", 3)(3, CoverPageModuleModalComponent_div_3_Template, 31, 13, "div", 4)(4, CoverPageModuleModalComponent_div_4_Template, 7, 0, "div", 4);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Generate Report");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isLoading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.isLoading && !ctx.fetchErrorOccurred);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.isLoading && ctx.fetchErrorOccurred);
    } }, dependencies: [i6.NgClass, i6.NgForOf, i6.NgIf, i7.DefaultValueAccessor, i7.NgControlStatus, i7.NgModel, i8.HelpModalComponent, i9.LoadingSymbolComponent, i10.ModalBaseComponent, i11.SimpleModalHeaderComponent, i12.SingleSelectDropdownComponent, i6.SlicePipe], encapsulation: 2 });
